import React, { Component } from 'react';
import { connect } from 'react-redux';
import format from 'date-fns/format';
import ScrollView from 'sub_components/Common/BloxScrollViewNew';
import { RESOLUTIONS as BREAKPOINTS } from 'services/config';
import { RESOLUTIONS } from 'services/config';
import { Utils } from 'services/utils';
import { PortraitModalComponent } from 'styled_components/Common/PortraitModalComponent';
import WhiteList from './Components/WhiteList';
const CDN_URL = process.env.REACT_APP_CDN_URL;
const AtlantaDefault = `${CDN_URL}common/atlanta-building-emerald-shadow.svg`;
const BirminghamDefault = `${CDN_URL}common/birmingham-building-emerald-shadow.svg`;
const ChattanoogaDefault = `${CDN_URL}common/chattanooga-building-emerald-shadow.svg`;
const HuntsvilleDefault = `${CDN_URL}common/huntsville-building-emerald-shadow.svg`;
//const LOCATIONS = { 3: 'atlanta', 1: 'birmingham', 2: 'chattanooga', 4: 'huntsville' };
const LOCATIONS = { 1: 'birmingham', 2: 'chattanooga', 4: 'huntsville' };

const MAX_VIPS_DISPLAYED = {
	[BREAKPOINTS.LOW]: 3,
	[BREAKPOINTS.MED]: 4,
	[BREAKPOINTS.HIGH]: 4,
};
class WhiteListModal extends Component {
	constructor(props) {
		super(props);

		this.state = {
			ips: [],
			dirty: [],
			lastElUpdated: null,
			allIpsValid: true,
			modalOpen: false,
			headerText: null,
			customImage: null,
			customTitle: null,
			modalContent: null,
		};
	}
	componentDidMount() {
		const { ips: { ips: existingIps, dirty } = {} } = this.props;
		if (existingIps) {
			this.setState({ ips: existingIps, dirty: dirty || [] });
		} else {
			this.setState({ ips: [] });
		}
	}

	formatDescription = (share, auth_status, vip) => {
		const {
			user: { firstname, lastname },
		} = auth_status;
		let description = '';
		description += `Share Name: ${share.common_name}\n `;
		description += `Share ID: ${share?.storage_id}\n `;
		description += `VIP IP: ${vip?.vip_address}/${vip?.vip_masklen}\n `;
		description += `Requestor: ${firstname}  ${lastname} \n`;
		description += `Time: ${format(new Date(), 'HH:mm')}`;
		return description;
	};

	getLocationImage = id => {
		if (!id) {
			return null;
		}
		if (LOCATIONS[id] === 'atlanta') {
			return AtlantaDefault;
		} else if (LOCATIONS[id] === 'birmingham') {
			return BirminghamDefault;
		} else if (LOCATIONS[id] === 'chattanooga') {
			return ChattanoogaDefault;
		} else {
			return HuntsvilleDefault;
		}
	};
	renderVipDetails = vip => {
		if (!vip) {
			return <div className='vip-details-whitelist'></div>;
		}
		return (
			<div className='vip-details-whitelist'>
				<div className='icon'>
					<img src={this.getLocationImage(vip.location)} />
					<div className='location-label labels21'>{LOCATIONS[vip.location]}</div>
				</div>
				<div className='vip-detail'>
					<div className='header heading60'>VIP DETAIL</div>
					<div className='body'>
						<div className='label body10'>IP</div>
						<div className='content body20'>{vip.vip_address}</div>
						<div className='label body10'>Subnet</div>
						<div className='content body20'>{vip.vip_netmask}</div>
						{vip?.isPrivate && (
							<>
								<div className='label body10'>VLAN</div>
								<div className='content body20'>{vip?.subnet_vlan}</div>
							</>
						)}
					</div>
				</div>
			</div>
		);
	};
	setDirtyAttributes = (index, ip) => {
		const results = Utils.splitIp(ip);
		const { dirty } = this.state;

		if (!dirty[index - 1]) {
			dirty[index - 1] = [];
		}
		dirty[index - 1] = results.pieces.map((piece, i) => {
			return parseInt(piece) || parseInt(piece) === 0 ? true : dirty[index - 1][i] || false;
		});

		return dirty[index - 1];
	};

	getSize = breakpoint => {
		let size = 'large';
		if (breakpoint === RESOLUTIONS.MED) {
			size = 'large';
		} else if (breakpoint === RESOLUTIONS.HIGH) {
			size = 'medium';
		}

		return size;
	};

	filterDuplicates = whitelists => {
		const uniqueWhitelists = [];
		whitelists.map(item => {
			const exists = uniqueWhitelists.some(object => {
				return object?.whitelist_ip_address === item?.whitelist_ip_address;
			});

			if (!exists) {
				uniqueWhitelists.push(item);
			}
		});
		return uniqueWhitelists;
	};

	render() {
		const {
			vip,
			share,
			shares,
			closeModal,
			showModal,
			breakpoint,
			editWhitelist,
			viewWhitelist,
			refreshShare,
			setModalContent,
		} = this.props;
		let storageWhiteList = vip?.whitelist;
		storageWhiteList = this.filterDuplicates(storageWhiteList);
		const scroll = !!(storageWhiteList && storageWhiteList.length > MAX_VIPS_DISPLAYED[breakpoint]);
		return (
			<PortraitModalComponent
				closeModal={closeModal}
				show={showModal}
				header={vip && this.renderVipDetails(vip)}
				title='WHITELIST Management'
				subTitle={`ACTIVE Whitelist`}
				size={this.getSize(breakpoint)}
				breakpoint={breakpoint}
			>
				{viewWhitelist && (
					<div className='whitelist-management'>
						{scroll && (
							<div className='whitelist-list scroll'>
								<ScrollView>
									{storageWhiteList &&
										storageWhiteList.length !== 0 &&
										storageWhiteList.map((whitelist, index) => (
											<WhiteList
												currentWhitelist={whitelist}
												index={index}
												type='Delete'
												share={share}
												shares={shares}
												setModalContent={setModalContent}
												editWhitelist={editWhitelist}
												refreshShare={refreshShare}
												vip={vip}
											/>
										))}
								</ScrollView>
							</div>
						)}
						{!scroll && (
							<div className='whitelist-list'>
								{storageWhiteList &&
									storageWhiteList.length !== 0 &&
									storageWhiteList.map((whitelist, index) => (
										<WhiteList
											currentWhitelist={whitelist}
											index={index}
											type='Delete'
											share={share}
											shares={shares}
											setModalContent={setModalContent}
											editWhitelist={editWhitelist}
											refreshShare={refreshShare}
											vip={vip}
										/>
									))}
							</div>
						)}
						<WhiteList
							type='Add'
							share={share}
							shares={shares}
							setModalContent={setModalContent}
							editWhitelist={editWhitelist}
							refreshShare={refreshShare}
							vip={vip}
							index={0}
						/>
					</div>
				)}
				{!viewWhitelist && (
					<div className='body10'>You do not have permission to view whitelists.</div>
				)}
			</PortraitModalComponent>
		);
	}
}

function mapStateToProps(state) {
	return {
		site: state.site_tracking,
		auth_status: state.auth_status,
		company_info: state.company_info,
	};
}

export default connect(mapStateToProps, null)(WhiteListModal);
